import { render } from "./estates.vue?vue&type=template&id=6f46a6b5&scoped=true"
import script from "./estates.vue?vue&type=script&lang=js"
export * from "./estates.vue?vue&type=script&lang=js"

import "./estates.vue?vue&type=style&index=0&id=6f46a6b5&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f46a6b5"]])

export default __exports__